<template>
  <div class="services__variant--wrapper services__variant--wrapper--2">
    <div class="services__variant services__variant--2" id="services__variant--2">
      <div class="services__variant--header">
        <h2 class="services__variant--header--title">
          {{ $t("servicesTranslate.servicesService2.title") }}
        </h2>
        <p class="services__variant--header--body">
          {{ $t("servicesTranslate.servicesService2.subtitle") }}
        </p>
        <router-link to="/contact" tag="a" class="services__variant--header--link">{{ $t("servicesTranslate.servicesService2.linkDesktop") }}</router-link>
      </div>
      <div class="services__variant--body">

        <div class="services__variant--body--block services__variant--body--block--1"></div>
        <div class="services__variant--body--block services__variant--body--block--2"></div>

        <div v-for="(step, index) in steps" :key="step.id" :class="['services__variant--body--step services__variant--body--step--' + (index + 1)]">
          <h2 class="services__variant--body--step--title">
            {{ $t(step.title) }}
          </h2>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'services__variant--2',
  data() {
    return {
      locale: 'fr',
      steps: [
        {
          title: "servicesTranslate.servicesService2.step1.title",
          excerpt: "servicesTranslate.servicesService2.step1.excerpt",
          link: "servicesTranslate.servicesService2.step1.link",
          body: "servicesTranslate.servicesService2.step1.linkContentBody",
          show: false
        },
        {
          title: "servicesTranslate.servicesService2.step2.title",
          excerpt: "servicesTranslate.servicesService2.step2.excerpt",
          link: "servicesTranslate.servicesService2.step2.link",
          body: "servicesTranslate.servicesService2.step2.linkContentBody",
          show: false
        },
        {
          title: "servicesTranslate.servicesService2.step3.title",
          excerpt: "servicesTranslate.servicesService2.step3.excerpt",
          link: "servicesTranslate.servicesService2.step3.link",
          body: "servicesTranslate.servicesService2.step3.linkContentBody",
          show: false
        }
      ]
    }
  },
  methods: {
    showAccordion(n) {
      for(var i = 0; i < this.steps.length; i++) {
        this.steps[i].show = false;
      }
      this.steps[n].show = true;
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>
